import type { Component } from "solid-js";
import { PromptBar } from "./PromptBar";
import type { PromptBarProps } from "./PromptBar.types";

/**
 * Wrapper component that renders just the PromptBar
 * WorkflowStatus has been removed
 */
export const PromptBarWithStatus: Component<PromptBarProps> = (props) => {
  return (
    <PromptBar
      onSubmit={props.onSubmit}
      streamingState={props.streamingState}
      onStopStreaming={props.onStopStreaming}
    />
  );
};
